import remove from 'lodash/remove';
import api from '@/api';
import { DeviceTypes } from '@/constants';

export default {
  namespaced: true,

  state: {
    devices: [],
    deviceTypeOptions: [],
    collectorTypeOptions: [],
    collectorProtocolOptions: [],
    gnssBaseStationDevicesOptions: [],
  },

  getters: {
    measuringDevices: (state) => {
      return state.devices.filter(item => item.type === DeviceTypes.Measuring);
    },
    collectorDevices: (state) => {
      return state.devices.filter(item => item.type === DeviceTypes.Collector);
    },
    dtuDevices: (state) => {
      return state.devices.filter(item => item.type === DeviceTypes.DTU);
    },
  },

  actions: {
    /**
     * 获取设备列表
     * params.corporationId 必需参数，企业ID
     * params.measuringAttributeType 可选参数，测量指标类型
     */
    async GetDevices({ commit }, params) {
      const { devices } = await api.device.getDevices({ ...params }, { showLoading: false });
      commit('SET_DEVICES', devices);
      return devices;
    },
    async GetGnssBaseStationDevicesOptions({ commit }, params) {
      const { options } = await api.device.GetGnssBaseStationDevicesOptions({ ...params });
      commit('SET_GNSS_BASE_STATION_DEVICES_OPTIONS', options);
      return options;
    },
    async GetDeviceTypeOptions({ commit }) {
      const { options } = await api.device.getDeviceTypeOptions();
      commit('SET_DEVICE_TYPE_OPTIONS', options);
      return options;
    },
    async GetCollectorTypeOptions({ commit }) {
      const { options } = await api.device.getCollectorTypeOptions();
      commit('SET_COLLECTOR_TYPE_OPTIONS', options);
      return options;
    },
    async GetCollectorProtocolOptions({ commit }, params) {
      const { options } = await api.device.getCollectorProtocolOptions({ ...params });
      commit('SET_COLLECTOR_PROTOCOL_OPTIONS', options);
      return options;
    },
    async AddDevice({ commit }, deviceForm) {
      const { device } = await api.device.addDevice({ ...deviceForm });
      commit('ADD_DEVICE', device);
      return device;
    },
    async UpdateDevice({ commit }, deviceForm) {
      const { device } = await api.device.putDevice({ ...deviceForm });
      commit('UPDATE_DEVICE', device);
      return device;
    },
    async DeleteDevice({ commit }, device) {
      await api.device.deleteDevice({
        corporationId: device.corporationId,
        deviceId: device.id,
      });
      commit('DELETE_DEVICE', device);
    },

    // 更新监测设备配置参数config
    async UpdateDeviceConfig({ commit }, configForm) {
      const { device } = await api.device.patchDeviceConfig({ ...configForm });
      commit('UPDATE_DEVICE', device);
      return device;
    },
    // 更新通道配置Config
    async UpdateDeviceChannelConfig({ commit }, configForm) {
      const { device } = await api.device.patchDeviceChannelConfig({ ...configForm });
      commit('UPDATE_DEVICE', device);
      return device;
    },
    // 更新数据处理配置Config
    async UpdateDeviceProcessorConfig({ commit }, configForm) {
      const { device } = await api.device.patchDeviceProcessorConfig({ ...configForm });
      commit('UPDATE_DEVICE', device);
      return device;
    },
    // 更新图表配置Config
    async UpdateDeviceChartConfig({ commit }, configForm) {
      const { device } = await api.device.patchDeviceChartConfig({ ...configForm });
      commit('UPDATE_DEVICE', device);
      return device;
    },
  },
  mutations: {
    SET_DEVICES(state, devices) {
      state.devices = devices;
    },
    SET_DEVICE_TYPE_OPTIONS(state, options) {
      state.deviceTypeOptions = options;
    },
    SET_COLLECTOR_TYPE_OPTIONS(state, options) {
      state.collectorTypeOptions = options;
    },
    SET_COLLECTOR_PROTOCOL_OPTIONS(state, options) {
      state.collectorProtocolOptions = options;
    },
    SET_GNSS_BASE_STATION_DEVICES_OPTIONS(state, options) {
      state.gnssBaseStationDevicesOptions = options;
    },
    ADD_DEVICE(state, device) {
      const { devices } = state;
      state.devices = [...devices, device];
    },
    UPDATE_DEVICE(state, device) {
      const { devices } = state;
      const target = devices.find(item => item.id === device.id);

      if (target) {
        Object.assign(target, device);
        state.devices = [...devices];
      }
    },
    DELETE_DEVICE(state, device) {
      const { devices } = state;
      remove(devices, item => item.id === device.id);
      state.devices = [...devices];
    },
  },
};
